




































































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum';
import { RankingElement } from '@empathybroker/tsclient-play/dist/models/ranking-element';

import { AttributeEntry, CrudForm, KeywordsInput, ProductsSearch, RegularFilterSelector, Tabs, UiButton, UiIcon } from '../../components';

import { DeviceEnum, FilterTypeEnum, GridDisplayEnum } from '../../enums';

import { CrudFormMixin } from '../../mixins/crud-form.mixin';

import { Dictionary, Filter, RegularFilter } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

export default {
  name: 'attributes-ranking-form',
  components: {
    AttributeEntry,
    CrudForm,
    KeywordsInput,
    ProductsSearch,
    RegularFilterSelector,
    UiButton,
    UiIcon,
    Tabs
  },
  mixins: [CrudFormMixin],
  created: function () {
    const filters: Dictionary<RegularFilter> = {};
    Object.values(this.context.filters)
      .filter((filter: Filter) => (filter.config.type === FilterTypeEnum.REGULAR))
      .forEach((filter: RegularFilter) => {
        filters[(filter.config.toolingId || filter.config.id)] = {
          config: {
            ...filter.config,
            mandatory: true,
            multiselectDisabled: true
          },
          selectedValues: [filter.config.values[0].id]
        };
      });
    this.searchFilters = filters;
    this.loadAttributeRankingEntrys();
  },
  computed: {
    filters: function (): Dictionary<RegularFilter> {
      const filters = CrudFormMixin.computed.filters.bind(this)();
      filters.lang.config.mandatory = true;
      return filters;
    },
    valid: function (): boolean {
      if (!this.item.filters.lang.length) {
        return false;
      }
      if (!this.item.keywords.length) {
        return false;
      }
      if (this.item.elements.every((element: RankingElement) => (!element.fieldName || !element.fieldValue))) {
        return false;
      }
      return true;
    },
    isHandheldDevice: function (): boolean {
      return this.$epb.device <= DeviceEnum.TABLET;
    },
    showConfiguration: function (): boolean {
      return !!this.item.keywords.length && !!this.item.filters.lang.length;
    },
    productSearchProps: function () {
      return {
        filters: this.searchFilters,
        searchParams: this.searchParams,
        componentsVisibility: { filters: true, textbox: false, keywords: true },
        gridItemsPerRow: this.itemsPerRow,
        messages: this.messages,
        suggestedKeywords: this.item.keywords
      };
    },
    configurationTabs: function () {
      const availableTabsIds = !this.isHandheldDevice ? (this.selectedConfigMode = RankingActionEnum.BOOST,
        Object.values(RankingActionEnum)) : [...Object.values(RankingActionEnum), 'LIST'];
      return availableTabsIds
        .map(tabId => ({
          id: tabId,
          icon: this.getActionIcon(tabId),
          text: !this.isHandheldDevice ? tabId : undefined
        }));
    },
    itemsPerRow: function () {
      const gridItems = {
        [DeviceEnum.DESKTOP]: {
          [GridDisplayEnum.BIG]: 3,
          [GridDisplayEnum.SMALL]: 2
        },
        [DeviceEnum.MOBILE]: {
          [GridDisplayEnum.BIG]: 2,
          [GridDisplayEnum.SMALL]: 1
        },
        'default': {
          [GridDisplayEnum.BIG]: 4,
          [GridDisplayEnum.SMALL]: 3
        }
      };
      return (gridItems[this.$epb.device] || gridItems['default']);
    }
  },
  data: function () {
    const messages = this.$epb.messages.tools.attributesRanking;
    return {
      dataType: ActionTypeEnum.ATTRIBUTES_RANKING,
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.attributesRanking.update),
      item: {
        enabled: true,
        keywords: [],
        elements: [],
        filters: {
          lang: []
        }
      },
      searchFilters: undefined,
      searchParams: {
        attributesRankingBoosts: '',
        attributesRankingBuries: ''
      },
      selectedConfigMode: RankingActionEnum.BOOST,
      messages: messages,
      DeviceEnum,
      RankingActionEnum,
      GridDisplayEnum
    };
  },
  methods: {
    addItemElement: function (action: string): void {
      this.item.elements.push({
        fieldName: '',
        fieldValue: '',
        action: action,
        schedule: {
          activationDate: null,
          deactivationDate: null
        },
        filters: {}
      });
    },
    getActionIcon: function (action) {
      return {
        [RankingActionEnum.BOOST]: 'boost',
        [RankingActionEnum.BURY]: 'bury',
        'LIST': 'preview'
      }[action];
    },
    filterElementsByAction: function (action: string): [] {
      return this.item.elements.filter((element: any) => element.action === action);
    },
    onChangeSearchFilter: function (filter: { filterId: string, newValue: string }) {
      this.searchFilters[filter.filterId].selectedValues = filter.newValue;
      this.setSearchParams();
    },
    isAttributeOnSelectedFilters: function (attribute): boolean {
      return Object.values(this.searchFilters).every((filter: RegularFilter) => {
        const attributeFilterValues = attribute.filters[(filter.config.toolingId || filter.config.id)];
        return (!attributeFilterValues || (attributeFilterValues.length === 0) ||
          attributeFilterValues.some((attributeFilterValue: string) => filter.selectedValues.includes(attributeFilterValue)));
      });
    },
    setSearchParams: function (): void {
      this.searchParams.attributesRankingBoosts = this.filterElementsByAction(RankingActionEnum.BOOST)
        .reduce((attributesParams: string[], attribute) => {
          if (this.isValidAttribute(attribute)) {
            attributesParams.push(`${ attribute.fieldName }:${ attribute.fieldValue }`);
          }
          return attributesParams;
        }, [])
        .join(',');
      this.searchParams.attributesRankingBuries = this.filterElementsByAction(RankingActionEnum.BURY)
        .reduce((attributesParams: string[], attribute) => {
          if (this.isValidAttribute(attribute)) {
            attributesParams.push(`${ attribute.fieldName }:${ attribute.fieldValue }`);
          }
          return attributesParams;
        }, [])
        .join(',');
    },
    isValidAttribute: function (attribute): boolean {
      return !!attribute.fieldName && attribute.fieldValue && this.isAttributeOnSelectedFilters(attribute);
    },
    onAccept: async function () {
      this.item.elements = this.item.elements.filter((element: any) => !!element.fieldName && !!element.fieldValue);
      CrudFormMixin.methods.onAccept.bind(this)();
    },
    onDeleteAttributesEntry: function (element: any): void {
      if (this.filterElementsByAction(element.action).length === 1) {
        this.addItemElement(element.action);
      }
      this.item.elements.splice(this.item.elements.indexOf(element), 1);
    },
    loadAttributeRankingEntrys: function (): void {
      Object.keys(RankingActionEnum).forEach((action) => {
        if (!this.filterElementsByAction(action).length) {
          this.addItemElement(action);
        }
      });
    }
  },
  watch: {
    'item.elements': {
      handler: function (): void {
        this.setSearchParams();
      },
      deep: true
    },
    'item.id': function (): void {
      this.loadAttributeRankingEntrys();
    }
  }
};
